module.exports = __webpack_public_path__ + "static/img/10003 (5).d7ec37b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10003 (5).webp
// module id = w4yK
// module chunks = 14